export const CREATION_DOCUMENT_FIELD_NAMES = [
  "courtOrder",
  "lastWill",
  "otherDocument",
];

export const RETRIEVAL_DOCUMENT_FIELD_NAMES = [
  "courtOrder",
  "lastWill",
  "otherDocument",
  "bondApp",
  "bond",
  "indemnity",
  "cancellationDocument",
  "endorsementDocument",
  "creditDocument",
  "fcraDocument",
];
